import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 10l-6 6v4h4l6 -6m1.99 -1.99l2.504 -2.504a2.828 2.828 0 1 0 -4 -4l-2.5 2.5","key":"svg-0"}],["path",{"d":"M13.5 6.5l4 4","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconPencilOff = createReactComponent('outline', 'pencil-off', 'PencilOff', __iconNode);

export default IconPencilOff;